// import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type {
  UseQueryOptions,
  UseQueryResult,
  QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { FlowInstance } from '../types/flow';
// import { stableStringify } from '@Utils/searchParams';

type FlowInstanceResponse = { data: FlowInstance[]; meta: Record<string, any> };
type DefaultError = unknown;

type UseFlowInstancesParams = {
  pageNumber?: number;
  pageSize?: number;
  include?: string;
  /** Override default enabled behavior */
  enabled?: boolean;
  flowId?: string;
  activeStageId?: string;
  categoryId?: string;
  [key: string]: string | number | boolean | undefined | null;
};

export function useFlowInstances<
  TData = FlowInstanceResponse,
  TError = DefaultError,
>(
  {
    // pageNumber = 1,
    // pageSize = 10,
    include,
    enabled = true,
    ...restParams
  }: UseFlowInstancesParams = {},
  flowId,
  activeStageId,
  categoryId,
  options?: Omit<
    UseQueryOptions<FlowInstanceResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = [
    'flowInstances',
    // pageNumber,
    // pageSize,
    include,
    activeStageId,
    restParams,
  ];

  return useQuery<FlowInstanceResponse, TError, TData>({
    queryKey,
    enabled,
    queryFn: async () => {
      return service.getFlowInstances(
        {
          // pageNumber,
          // pageSize,
          ...(include ? { include } : {}),
          ...(restParams ? { ...restParams } : {}),
        },
        flowId,
        activeStageId,
        categoryId,
      );
    },
    ...(options as any),
  });
}
